import { render, staticRenderFns, recyclableRender, components } from "./uni-drawer.vue?vue&type=template&id=558f1882&scoped=true&"
var renderjs
import script from "./uni-drawer.vue?vue&type=script&lang=js&"
export * from "./uni-drawer.vue?vue&type=script&lang=js&"
import style0 from "./uni-drawer.vue?vue&type=style&index=0&id=558f1882&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!C:\\Users\\dell\\Downloads\\HBuilderX.3.2.16.20211122.full\\HBuilderX\\plugins\\uniapp-cli\\node_modules\\@dcloudio\\vue-cli-plugin-uni\\packages\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "558f1882",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "uni_modules/uni-drawer/components/uni-drawer/uni-drawer.vue"
export default component.exports